module.exports = __webpack_public_path__ + "7f58e2c266e5c59a10c0651b7da4adff.png";